export default __webpack_public_path__ + "static/media/resnetgrutable2.1dd9b81d.png";